import './index.css';
import App from './components/App';
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { RootStore } from './models/RootStore'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export const rootStore = RootStore.create();

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDeWg6sdmdWtnBuOZI120o4RuqqES_k4nU",
  authDomain: "mach2app.firebaseapp.com",
  databaseURL: "https://mach2app.firebaseio.com",
  projectId: "mach2app",
  storageBucket: "mach2app.appspot.com",
  messagingSenderId: "114758463471"
};
firebase.initializeApp(config);

export const auth = firebase.auth()

export const db = firebase.firestore()
const dbSettings = { timestampsInSnapshots: true };
db.settings(dbSettings);



ReactDOM.render(<Provider store={rootStore}><App /></Provider>, document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.js